export const orderIsDistribturorSignup = (order: any) => {
    return order.attributes.enrollmentRules
        && order.attributes.enrollmentRules.orderIsEnrollment === true
        && order.attributes.newProfile
        && order.attributes.newProfile.status === 'D';
};
